// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-6d60caee]{text-align:right}.detail[data-v-6d60caee]{color:#666;font-size:.8em}.per[data-v-6d60caee]{font-style:italic;text-align:center;width:100%;display:block}.spacer[data-v-6d60caee]{height:24px}.spacer *[data-v-6d60caee]{position:relative;top:50%}.swatch[data-v-6d60caee]{width:12px;height:12px;content:\" \";display:block;background:#00f}", ""]);
// Exports
module.exports = exports;
